import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setArticleBaseModal } from '../actions/modalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import ArticleBaseListItem from '../../components/ArticleBaseListItem'
import $ from 'jquery'
import * as resource from '../../constants/Resources'
import { getTranslation, getArticleDescription } from '../../actions/dataActions'

class ArticleBaseModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.removeTap = this.removeTap.bind(this);
        this.resetTap = this.resetTap.bind(this);
        this.updateInputField = this.updateInputField.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
        this.showKeyboard = this.showKeyboard.bind(this);
        this.filterArticles = this.filterArticles.bind(this);
        this.state = {
            inputField: ''
        };
    }

    cancelTap() {
        this.props.setArticleBaseModal([], false, 'default');
    }

    removeTap() {
        this.processTouchTap(null);
        this.props.setArticleBaseModal([], false, 'default');
    }

    resetTap() {
        $('#search').val('');
        this.setState({ inputField: '' });
    }

    processTouchTap(article) {
        const callback = this.props.articleBaseModal.callback;
        const dispatch = this.props.articleBaseModal.dispatch;

        let callbackParams = [article];

        if (this.props.articleBaseModal.callbackparams !== undefined) {
            this.props.articleBaseModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.setState({ inputField: '' });
        this.props.setArticleBaseModal([], false, 'default');

        if (callback !== null) {
            if (dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    updateInputField(input) {
        this.setState({ inputField: input });
    }

    showKeyboard() {
        this.setState({ inputField: '' });
        this.props.toggleKeyboard(true, '#search',  this.props.getTranslation(resource.SEARCH_TERM), this.updateInputField, [$('#search').val()]);
    }

    filterArticles(articles, inputField) {
        let newlist = articles.filter(({ article: a, description }) => {
            let articlenumber = a.ArticleNumber != null? a.ArticleNumber.toLowerCase():'';
            let input = inputField.toLowerCase();
            let barcodeMatch = a.Barcodes != null && a.Barcodes.some(b => b != null && b.toLowerCase().includes(input));

            return articlenumber.includes(input) || description.toLowerCase().includes(input) || barcodeMatch
        });

        return newlist;
    }

    render() {
        //Resolve the translated description once so filtering, sorting, and rendering all use the same value.
        const decoratedArticles = this.props.articleBaseModal.listvalues.map((article) => ({
            article,
            description: this.props.getArticleDescription(article) || ''
        }));
        const newList = this.filterArticles(decoratedArticles, this.state.inputField);
        return (
            <Modal className='articleBaseModal'
                contentLabel=""
                isOpen={this.props.articleBaseModal.show}
                style={properties.articleBaseModalStyle}
            >
                <div className="articleBaseModal_header">
                    <div className="header_top">
                    {this.props.getTranslation(resource.ARTICLE_LIST)}
                    </div>
                </div>
                <div className="articleBaseModal_content">
                    <div>
                        <div className="search_bar_div">
                            <input
                                id="search"
                                className="search_bar"
                                placeholder={this.props.getTranslation(resource.SEARCH_TERM)}
                                onClick={this.showKeyboard}
                                readOnly="readOnly" />
                            {this.state.inputField !== '' &&
                                <button className="btnReset" onClick={this.resetTap} >
                                   {this.props.getTranslation(resource.RESET)}
                                </button>
                            }
                        </div>
                        <div className="articleList" >
                            {
                                newList.slice(0, 300).sort((a, b) => (a.description > b.description) ? 1 : -1).map(({ article, description }) =>
                                    <ArticleBaseListItem
                                        key={article.ArticleId}
                                        Article={article}
                                        Description={description}
                                        Callback={this.processTouchTap}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="articleBaseModal_footer">
                    <button className="btnCancel" style={{ width: "100%" }} onClick={this.cancelTap} >
                    {this.props.getTranslation(resource.CANCEL)}
                    </button>
                </div>

            </Modal>
        )
    }
}

ArticleBaseModal.propTypes = {
}


function mapStateToProps(state) {
    return {
        articleBaseModal: state.modalState.articleBaseModal,
        keyboard: state.layoutState.keyboard,
        //Re-render the list, with descriptions re-resolved, when the customer switches language.
        culture: state.layoutState.language.culture,
    }
}

export default connect(mapStateToProps, {
    setArticleBaseModal,
    toggleKeyboard,
    getTranslation,
    getArticleDescription
})(ArticleBaseModal)



// WEBPACK FOOTER //
// src/modal/components/ArticleBaseModal.jsx